import { NavItem } from '@im/ui-lib/nav';
import { useMemo } from 'react';
import { useVendorsMenuQuery, Vendor } from '../../hooks/use-vendorsmenu';
import { validateProperty } from './utils';

export function useVendorsNavItems(locale: string, enabled: boolean) {
  const result = useVendorsMenuQuery(locale, enabled);

  const vendors = useMemo(() => {
    if (result.data?.menuitems?.length) {
      localStorage.setItem(
        'localLeftNavVendorList',
        JSON.stringify(result.data?.menuitems?.map((a: Vendor) => a.vendorName))
      );
    }
    const filterLeftNavList = result.data?.menuitems?.filter(
      (x: Vendor) => x.isLeftNav === true
    );

    return {
      menuitems: filterLeftNavList,
      total: filterLeftNavList?.length ?? 0,
    };
  }, [result.data]);

  return useMemo<NavItem[]>(() => {
    const navItems: NavItem[] = [];
    const count =
      vendors && vendors.total && vendors.total > 0 ? vendors.total : 0;

    if (count > 0) {
      for (let i = 0; i <= count; i++) {
        const key = validateProperty(vendors, 'vendorName', i);
        const pageName = validateProperty(vendors, 'pageName', i);
        const partialPageUrl = validateProperty(vendors, 'partialPageUrl', i);
        const searchUrl = validateProperty(vendors, 'searchUrl', i);
        const pagePath = partialPageUrl
          ? partialPageUrl.split('/').pop() ?? ''
          : '';
        if (key !== '') {
          navItems.push({
            key,
            label: pageName,
            route: searchUrl
              ? `/product/productsearch?title=${encodeURIComponent(
                  key
                )}&pageName=${encodeURIComponent(pagePath)}&${searchUrl}`
              : `/product/productsearch?title=${encodeURIComponent(
                  key
                )}&vendor=${encodeURIComponent(
                  key
                )}&pageName=${encodeURIComponent(pagePath)}`,
          });
        }
      }
    }

    return navItems;
  }, [vendors]);
}
